var cilClearAll = ["512 512", "<rect width='336' height='32' x='160' y='112' fill='var(--ci-primary-color, currentColor)' class='ci-primary'/><rect width='336' height='32' x='88' y='240' fill='var(--ci-primary-color, currentColor)' class='ci-primary'/><rect width='336' height='32' x='16' y='368' fill='var(--ci-primary-color, currentColor)' class='ci-primary'/>"];

export { cilClearAll };

